<template>
  <div id="RetryQueueTable">
    <div v-if="noRetryQueue" class="container">
      <div class="section" style="padding-top: 3rem !important">
        <p class="subtitle is-6" style="color: #8c8c8c;">{{ noRetryQueue }}</p>
      </div>
    </div>
    <div v-else class="container">
      <!-- Prospect Customer List -->
      <b-table
        detailed
        :data="retryQueueList"
        :striped="true"
        :show-detail-icon="true"
      >
        <template slot-scope="props">
          <b-table-column
            field="transaction_id"
            :label="$t('customer.tabs.table.retry_queue.transaction_id')"
            >{{ props.row.transaction_id }}
          </b-table-column>
          <b-table-column
            field="create_date"
            :label="$t('customer.tabs.table.created')"
            >{{ props.row.create_date | dateformatter }}</b-table-column
          >
          <b-table-column
            field="retry_count"
            :label="$t('customer.tabs.table.retry_queue.retry_count')"
            >{{ props.row.retry_count }}</b-table-column
          >
          <b-table-column
            field="msisdn"
            :label="$t('customer.tabs.table.retry_queue.next_retry')"
            >{{ props.row.next_run | dateformatter }}</b-table-column
          >
          <b-table-column
            field="type"
            :label="$t('customer.tabs.table.retry_queue.type')"
          >
            <span class="tag is-pink">{{ props.row.type }}</span>
          </b-table-column>
        </template>
        <!-- Payload Detail window -->
        <template slot="detail" slot-scope="props">
          <div class="container">
            <p>Payload: {{ props.row.payload }}</p>
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import AlertManager from "@/managers/AlertManager";
import CustomerApiManager from "@/apis/CustomerApiManager";

export default {
  name: "RetryQueueTable",
  props: ["customer_id", "enable"],
  data() {
    return {
      noRetryQueue: null,
      retryQueueList: []
    };
  },
  watch: {
    enable: function(val) {
      if (val) this.getRetryQueue();
    }
  },
  filters: {
    dateformatter: function(value) {
      if (!value) return "";
      return dayjs(value).format("DD/MM/YYYY @ HH:mm");
    }
  },
  methods: {
    getRetryQueue: async function() {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      });
      const retryQueueResult = await CustomerApiManager.requestRetryQueue(
        this.customer_id
      );
      loadingComponent.close();

      switch (retryQueueResult.code) {
        case "0":
          if (retryQueueResult.data.retry_queue.length > 0) {
            this.noRetryQueue = null;
            this.retryQueueList = retryQueueResult.data.retry_queue;
          } else {
            this.noRetryQueue = this.$t(
              "customer.tabs.table.retry_queue.not_found"
            );
          }
          break;

        default:
          AlertManager.showErrorSnackbar(retryQueueResult.message);
          break;
      }
    }
  },
  mounted() {
    if (this.enable) this.getRetryQueue();
  }
};
</script>

<style></style>
